import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import Logo from "@/components/xuma/Logo";

export const Navbar = () => {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-xuma-border">
      <nav className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <Logo variant="dark" size="md" />
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm text-xuma-muted">
          <a href="/#features" className="hover:text-xuma-dark transition-colors">Funciones</a>
          <a href="/#pricing" className="hover:text-xuma-dark transition-colors">Planes</a>
          <a href="/#faq" className="hover:text-xuma-dark transition-colors">Preguntas</a>
        </div>

        <div className="flex items-center gap-2">
          {user ? (
            <Link to="/dashboard">
              <Button data-testid="nav-dashboard-btn" className="bg-xuma-dark hover:bg-black text-white rounded-full px-5">
                Mi panel
              </Button>
            </Link>
          ) : (
            <>
              <Link to="/login" className="hidden sm:block">
                <Button data-testid="nav-login-btn" variant="ghost" className="rounded-full text-xuma-dark hover:bg-xuma-dash">
                  Entrar
                </Button>
              </Link>
              <Link to="/register">
                <Button data-testid="nav-register-btn" className="bg-xuma-primary hover:bg-xuma-primaryHover text-white rounded-full px-5">
                  Crear mi tarjeta
                </Button>
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
